<template>
  <div class="vc-call-basic">
  <div class="vc-section vc-card vc-card--compact">
    <div class="vc-call-row vc-call-row--duration">
      <span class="vc-call-row__req">*</span>
      <span class="vc-call-row__label">最大通话时长</span>
      <div class="vc-call-duration">
        <InputNumber
          v-model="callControl.max_call_duration"
          :min="1"
          :precision="0"
          class="vc-call-duration__input"
        />
        <span class="vc-call-duration__unit">秒</span>
      </div>
    </div>

    <div class="vc-call-row vc-call-row--duration">
      <span class="vc-call-row__req">*</span>
      <span class="vc-call-row__label">振铃时长</span>
      <div class="vc-call-duration">
        <InputNumber
          v-model="callControl.call_timeout"
          :min="1"
          :precision="0"
          class="vc-call-duration__input"
        />
        <span class="vc-call-duration__unit">秒</span>
      </div>
    </div>

    <div class="vc-call-divider" role="separator" />

    <div class="vc-call-collapse vc-call-collapse--static">
      <div class="vc-call-collapse__hd">
        <span class="vc-call-row__req">*</span>
        <span class="vc-call-collapse__title">静默提示语</span>
      </div>
      <div class="vc-call-collapse__bd vc-call-collapse__bd--silence">
        <div class="vc-call-inline">
          <span class="vc-call-inline__label">等待响应超时时长</span>
          <div class="vc-call-inline__control">
            <div class="vc-call-duration">
              <InputNumber
                v-model="callControl.input_timeout"
                :min="1"
                :precision="0"
                class="vc-call-duration__input vc-call-duration__input--wide"
              />
              <span class="vc-call-duration__unit">ms</span>
            </div>
          </div>
        </div>

        <div
          v-for="(prompt, index) in callControl.silence_prompts"
          :key="'silence-' + index"
          class="vc-call-inline vc-call-inline--prompt"
        >
          <span class="vc-call-inline__label vc-call-inline__label--prompt">
            <button
              v-if="canRemoveSilencePrompt(index)"
              type="button"
              class="vc-silence-remove-btn"
              title="删除提示语"
              @click="removeSilencePrompt(index)"
            >
              <Icon type="ios-close" :size="16" />
            </button>
            <span
              v-else
              class="vc-silence-remove-btn vc-silence-remove-btn--spacer"
              aria-hidden="true"
            />
            <span class="vc-call-inline__label-text">提示语 {{ index + 1 }}</span>
          </span>
          <div class="vc-call-inline__control">
            <div
              class="vc-prompt-input-wrap"
              :class="{ 'has-audio': !!prompt.audio_file_path }"
            >
              <Input
                v-model="prompt.text"
                :maxlength="500"
                placeholder="请输入静默提示语"
                class="vc-prompt-input"
              />
              <div class="vc-prompt-input__actions">
                <Button
                  v-if="!getPromptAudioName(prompt)"
                  class="vc-opening-tool-btn vc-opening-tool-btn--compact"
                  :loading="uploadingKey === 'silence-' + index"
                  @click="triggerUpload('silence-' + index)"
                >
                  <Icon type="ios-cloud-upload-outline" size="12" />
                  上传音频
                </Button>
                <div v-if="getPromptAudioName(prompt)" class="vc-audio-tag vc-audio-tag--inline">
                  <span class="vc-audio-tag__name" :title="getPromptAudioName(prompt)">
                    {{ getPromptAudioName(prompt) }}
                  </span>
                  <button
                    type="button"
                    class="vc-audio-tag__del"
                    title="删除录音"
                    @click="clearSilenceAudio(index)"
                  >
                    <Icon type="ios-trash-outline" size="12" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vc-call-inline vc-call-inline--add-prompt">
          <span class="vc-call-inline__label vc-call-inline__label--prompt">
            <span class="vc-silence-remove-btn vc-silence-remove-btn--spacer" aria-hidden="true" />
            <span class="vc-call-inline__label-text vc-call-inline__label-text--empty" aria-hidden="true" />
          </span>
          <div class="vc-call-inline__control">
            <button
              type="button"
              class="vc-silence-add-btn"
              :disabled="!canAddSilencePrompt"
              @click="addSilencePrompt"
            >
              + 新增提示语
            </button>
          </div>
        </div>

        <div class="vc-call-inline">
          <span class="vc-call-inline__label">最大连续超时次数</span>
          <div class="vc-call-inline__control">
            <InputNumber
              v-model="callControl.max_timeouts"
              :min="1"
              :precision="0"
              class="vc-call-duration__input"
            />
          </div>
        </div>

        <div class="vc-call-inline vc-call-inline--prompt">
          <span class="vc-call-inline__label vc-call-inline__label--prompt">
            <span class="vc-silence-remove-btn vc-silence-remove-btn--spacer" aria-hidden="true" />
            <span class="vc-call-inline__label-text">挂断语</span>
          </span>
          <div class="vc-call-inline__control">
            <div
              class="vc-prompt-input-wrap"
              :class="{ 'has-audio': !!callControl.goodbye.audio_file_path }"
            >
            <Input
              v-model="callControl.goodbye.text"
              :maxlength="500"
              placeholder="请输入挂断语"
              class="vc-prompt-input"
            />
            <div class="vc-prompt-input__actions">
              <Button
                v-if="!goodbyeAudioName"
                class="vc-opening-tool-btn vc-opening-tool-btn--compact"
                :loading="uploadingKey === 'goodbye'"
                @click="triggerUpload('goodbye')"
              >
                <Icon type="ios-cloud-upload-outline" size="12" />
                上传音频
              </Button>
              <div v-if="goodbyeAudioName" class="vc-audio-tag vc-audio-tag--inline">
                <span class="vc-audio-tag__name" :title="goodbyeAudioName">{{ goodbyeAudioName }}</span>
                <button type="button" class="vc-audio-tag__del" title="删除录音" @click="clearAudio('goodbye')">
                  <Icon type="ios-trash-outline" size="12" />
                </button>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>

    <input
      ref="audioFileInput"
      type="file"
      accept=".wav,audio/wav,audio/x-wav"
      class="vc-hidden-file"
      @change="handleAudioFileChange"
    />
  </div>

  <div class="vc-section vc-card vc-card--compact vc-bg-sound">
    <div class="vc-bg-sound__row">
      <span class="vc-bg-sound__label">通话背景音</span>
      <div ref="backgroundSoundControls" class="vc-bg-sound__controls">
        <div class="vc-bg-sound__select-wrap" :class="{ 'has-value': !!backgroundSoundId }">
          <Select
            :value="backgroundSoundId"
            class="vc-bg-sound__select"
            transfer
            placeholder="请选择"
            :loading="backgroundSoundLoading"
            @on-change="onBackgroundSoundChange"
          >
            <Option
              v-for="item in backgroundSoundSelectOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </Option>
          </Select>
          <button
            v-if="backgroundSoundId"
            type="button"
            class="vc-bg-sound__clear"
            title="删除背景音"
            @click.stop="clearBackgroundSound"
          >
            <Icon type="ios-close-circle" size="14" />
          </button>
        </div>
        <div class="vc-bg-sound__volume">
          <button
            type="button"
            class="vc-bg-sound__gear"
            :class="{ 'is-open': volumeOpen }"
            title="音量"
            :aria-expanded="volumeOpen ? 'true' : 'false'"
            @click="volumeOpen = !volumeOpen"
          >
            <Icon type="ios-settings" size="16" />
          </button>
          <div v-if="volumeOpen" class="vc-bg-sound__popover" @mousedown.stop>
            <span class="vc-bg-sound__popover-label">音量</span>
            <Slider
              :value="backgroundVolume"
              class="vc-bg-sound__slider"
              :min="volumeMin"
              :max="volumeMax"
              :step="0.1"
              show-tip="never"
              @input="onBackgroundVolumeChange"
              @on-change="onBackgroundVolumeChange"
            />
            <InputNumber
              :value="backgroundVolume"
              class="vc-bg-sound__volume-input"
              :min="volumeMin"
              :max="volumeMax"
              :step="0.1"
              :precision="1"
              :active-change="false"
              @on-change="onBackgroundVolumeChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import {
  BACKGROUND_SOUND_VOLUME_MAX,
  BACKGROUND_SOUND_VOLUME_MIN,
  clampBackgroundSoundVolume,
  createDefaultBackgroundSound,
  createEmptyBackgroundSound,
  DEFAULT_BACKGROUND_SOUND_VOLUME,
  fetchBackgroundSoundOptions,
  getBuiltinBackgroundSoundOptions,
} from '../../utils/backgroundSound'
import {
  createEmptySilencePrompt,
  DEFAULT_SILENCE_PROMPT_COUNT,
  getAudioFileName,
} from '../../utils/callControlHelpers'
import { uploadAudioFile } from './audioUploadHelper'

const MAX_SILENCE_PROMPTS = 5

export default {
  name: 'CallControlSection',
  props: {
    callControl: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      uploadingKey: '',
      pendingUploadKey: '',
      backgroundSoundOptions: getBuiltinBackgroundSoundOptions(),
      backgroundSoundLoading: false,
      volumeOpen: false,
      volumeMin: BACKGROUND_SOUND_VOLUME_MIN,
      volumeMax: BACKGROUND_SOUND_VOLUME_MAX,
    }
  },
  computed: {
    goodbyeAudioName() {
      return getAudioFileName(this.callControl.goodbye.audio_file_path)
    },
    canAddSilencePrompt() {
      const list = this.callControl.silence_prompts
      return Array.isArray(list) && list.length < MAX_SILENCE_PROMPTS
    },
    backgroundSound() {
      const current = this.callControl && this.callControl.background_sound
      return current && typeof current === 'object' ? current : createDefaultBackgroundSound()
    },
    backgroundSoundId() {
      return this.backgroundSound.sound_id || ''
    },
    backgroundVolume() {
      const volume = this.backgroundSound.volume
      return volume != null ? volume : DEFAULT_BACKGROUND_SOUND_VOLUME
    },
    backgroundSoundSelectOptions() {
      const options = Array.isArray(this.backgroundSoundOptions)
        ? this.backgroundSoundOptions.slice()
        : []
      const current = this.backgroundSound
      const id = current.sound_id ? String(current.sound_id) : ''
      if (id && !options.some((item) => item.value === id)) {
        options.unshift({
          value: id,
          label: current.sound_name || id,
          audio_file_path: current.audio_file_path || '',
        })
      }
      return options
    },
  },
  created() {
    this.ensureBackgroundSoundField()
    this.loadBackgroundSoundOptions()
  },
  mounted() {
    document.addEventListener('mousedown', this.onDocumentMouseDown)
    document.addEventListener('keydown', this.onDocumentKeyDown)
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.onDocumentMouseDown)
    document.removeEventListener('keydown', this.onDocumentKeyDown)
  },
  methods: {
    addSilencePrompt() {
      if (!this.canAddSilencePrompt) {
        this.$Message.warning(`最多添加 ${MAX_SILENCE_PROMPTS} 条提示语`)
        return
      }
      this.callControl.silence_prompts.push(createEmptySilencePrompt())
    },
    canRemoveSilencePrompt(index) {
      const list = this.callControl.silence_prompts
      if (!Array.isArray(list) || list.length <= DEFAULT_SILENCE_PROMPT_COUNT) return false
      return index >= DEFAULT_SILENCE_PROMPT_COUNT
    },
    removeSilencePrompt(index) {
      if (!this.canRemoveSilencePrompt(index)) return
      this.callControl.silence_prompts.splice(index, 1)
    },
    getPromptAudioName(prompt) {
      if (!prompt) return ''
      return getAudioFileName(prompt.audio_file_path)
    },
    triggerUpload(key) {
      this.pendingUploadKey = key
      const input = this.$refs.audioFileInput
      if (!input) return
      input.value = ''
      input.click()
    },
    async handleAudioFileChange(event) {
      const file = event.target.files && event.target.files[0]
      const key = this.pendingUploadKey
      if (!file || !key) return

      this.uploadingKey = key
      try {
        const { filePath } = await uploadAudioFile(file, { message: this.$Message })
        this.applyUploadedPath(key, filePath)
        this.$Message.success('上传成功')
      } catch (e) {
        this.$Message.error((e && e.message) || '上传失败')
      } finally {
        this.uploadingKey = ''
        this.pendingUploadKey = ''
      }
    },
    applyUploadedPath(key, filePath) {
      const path = String(filePath || '').trim()
      if (!path) return
      if (key === 'goodbye') {
        this.$set(this.callControl.goodbye, 'audio_file_path', path)
        return
      }
      if (String(key).startsWith('silence-')) {
        const index = Number(String(key).replace('silence-', ''))
        if (!Number.isFinite(index) || !this.callControl.silence_prompts[index]) return
        this.$set(this.callControl.silence_prompts[index], 'audio_file_path', path)
      }
    },
    clearAudio(key) {
      if (key === 'goodbye') {
        this.$set(this.callControl.goodbye, 'audio_file_path', '')
      }
    },
    clearSilenceAudio(index) {
      if (!this.callControl.silence_prompts[index]) return
      this.$set(this.callControl.silence_prompts[index], 'audio_file_path', '')
    },
    ensureBackgroundSoundField() {
      const current = this.callControl.background_sound
      if (!current || typeof current !== 'object') {
        this.$set(this.callControl, 'background_sound', createDefaultBackgroundSound())
        return
      }
      if (current.volume == null || !Number.isFinite(Number(current.volume))) {
        this.$set(this.callControl.background_sound, 'volume', DEFAULT_BACKGROUND_SOUND_VOLUME)
      }
      const soundId = String(current.sound_id || '').trim()
      if (soundId && !current.sound_name) {
        const defaults = createDefaultBackgroundSound()
        const name = soundId === defaults.sound_id ? defaults.sound_name : soundId
        this.$set(this.callControl.background_sound, 'sound_name', name)
      }
    },
    async loadBackgroundSoundOptions() {
      this.backgroundSoundLoading = true
      try {
        const list = await fetchBackgroundSoundOptions()
        this.backgroundSoundOptions = Array.isArray(list) ? list : []
        this.syncBackgroundSoundFromOptions()
      } catch (e) {
        this.backgroundSoundOptions = []
      } finally {
        this.backgroundSoundLoading = false
      }
    },
    syncBackgroundSoundFromOptions() {
      const id = this.backgroundSoundId
      if (!id) return
      const option = this.backgroundSoundOptions.find((item) => item.value === id)
      if (!option) return
      this.ensureBackgroundSoundField()
      if (option.label && this.callControl.background_sound.sound_name !== option.label) {
        this.$set(this.callControl.background_sound, 'sound_name', option.label)
      }
      if (option.audio_file_path) {
        this.$set(this.callControl.background_sound, 'audio_file_path', option.audio_file_path)
      }
    },
    onBackgroundSoundChange(value) {
      this.ensureBackgroundSoundField()
      const id = value != null ? String(value).trim() : ''
      if (!id) {
        this.clearBackgroundSound()
        return
      }
      const option = this.backgroundSoundSelectOptions.find((item) => item.value === id) || null
      this.$set(this.callControl.background_sound, 'sound_id', id)
      this.$set(
        this.callControl.background_sound,
        'sound_name',
        option ? option.label : id,
      )
      this.$set(
        this.callControl.background_sound,
        'audio_file_path',
        option && option.audio_file_path ? option.audio_file_path : '',
      )
    },
    clearBackgroundSound() {
      this.ensureBackgroundSoundField()
      const volume = this.callControl.background_sound.volume
      const cleared = createEmptyBackgroundSound(volume)
      this.$set(this.callControl, 'background_sound', cleared)
      this.volumeOpen = false
    },
    onBackgroundVolumeChange(value) {
      this.ensureBackgroundSoundField()
      this.$set(this.callControl.background_sound, 'volume', clampBackgroundSoundVolume(value))
    },
    onDocumentMouseDown(event) {
      if (!this.volumeOpen) return
      const root = this.$refs.backgroundSoundControls
      if (root && root.contains(event.target)) return
      this.volumeOpen = false
    },
    onDocumentKeyDown(event) {
      if (!this.volumeOpen) return
      if (event.key === 'Escape') this.volumeOpen = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import './shared.scss';

.vc-section {
  margin-bottom: 16px;
}

.vc-card {
  background: #fff;
  border: 1px solid #e8eaec;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  padding: 20px;
}

.vc-card--compact {
  padding-bottom: 16px;
}

.vc-call-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  &__req {
    width: 10px;
    flex-shrink: 0;
    color: #ed4014;
    font-size: 13px;
    line-height: 1;

    &--empty::before {
      content: '\00a0';
      visibility: hidden;
    }
  }

  &__label {
    font-size: 13px;
    font-weight: 500;
    color: #262626;
    flex-shrink: 0;
  }

  &--duration .vc-call-duration {
    margin-left: 8px;
  }

  &--duration {
    margin-bottom: 16px;
  }

  &--toggle .ivu-switch {
    margin-left: 8px;
  }
}

.vc-call-divider {
  border: none;
  border-top: 1px solid #f0f0f0;
  margin: 0 0 16px;
}

.vc-call-duration {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &__input {
    width: 100px;

    &--wide {
      width: 120px;
    }
  }

  &__unit {
    font-size: 13px;
    color: #8c8c8c;
  }
}

.vc-call-collapse {
  margin-bottom: 0;

  &__hd {
    display: flex;
    align-items: center;
    padding: 6px 0;
  }

  &--static > &__hd {
    cursor: default;
    padding: 0 0 12px;
    user-select: text;
  }

  &__title {
    font-size: 13px;
    font-weight: 500;
    color: #262626;
  }

  &__hint {
    margin-left: 8px;
    font-size: 12px;
    color: #8c8c8c;
  }

  &__bd {
    padding: 10px 0 4px 14px;

    &--silence {
      padding-left: 14px;

      .vc-call-inline__label {
        width: 140px;
        min-width: 140px;
      }

      .vc-call-inline__control {
        flex: 1;
        min-width: 0;
        display: flex;
        align-items: center;
      }

      .vc-call-inline__label--prompt {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        box-sizing: border-box;
      }

      .vc-call-inline__label-text {
        flex: 1;
        min-width: 0;
        text-align: left;
        white-space: nowrap;
      }

      .vc-prompt-input-wrap {
        width: 100%;
      }
    }
  }
}

.vc-call-inline {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;

  &__label {
    flex-shrink: 0;
    min-width: 112px;
    font-size: 13px;
    color: #262626;
  }

  &--prompt {
    align-items: flex-start;

    .vc-call-inline__label {
      line-height: 32px;
    }
  }

  &--add-prompt {
    margin-bottom: 12px;

    .vc-call-inline__label-text--empty {
      visibility: hidden;
    }
  }
}

.vc-silence-remove-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #909399;
  cursor: pointer;
  flex-shrink: 0;
  line-height: 1;
  transition: background 0.15s ease, color 0.15s ease;

  ::v-deep .ivu-icon {
    line-height: 1;
    color: inherit;
    transition: color 0.15s ease;
  }

  &:hover,
  &:focus-visible {
    background: #ffecec;
    color: #ed4014;
  }

  &:active {
    background: #ffd6d6;
    color: #c03;
  }

  &--spacer {
    visibility: hidden;
    pointer-events: none;
  }
}

.vc-silence-add-btn {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: 2px 8px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #2d8cf0;
  font-size: 13px;
  line-height: 22px;
  cursor: pointer;
  transition: color 0.15s ease, background 0.15s ease;

  &:hover:not(:disabled) {
    color: #1677ff;
    background: #f0f9ff;
  }

  &:disabled {
    color: #c5c8ce;
    cursor: not-allowed;
  }
}

.vc-prompt-input-wrap {
  flex: 1;
  min-width: 0;
  position: relative;

  &.has-audio .vc-prompt-input ::v-deep .ivu-input {
    padding-right: 148px;
  }

  &:not(.has-audio) .vc-prompt-input ::v-deep .ivu-input {
    padding-right: 108px;
  }
}

.vc-prompt-input__actions {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 1;
}

.vc-audio-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 160px;
  padding: 2px 6px;
  background: #ecf5ff;
  border: 1px solid #b3d8ff;
  border-radius: 4px;

  &--inline {
    max-width: 120px;
  }

  &__name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 11px;
    color: #262626;
  }

  &__del {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    padding: 0;
    border: none;
    background: transparent;
    color: #8c8c8c;
    cursor: pointer;

    &:hover {
      color: #ed4014;
    }
  }
}

.vc-opening-tool-btn {
  height: 28px;
  padding: 0 10px !important;
  border: 1px solid #dcdee2 !important;
  border-radius: 4px !important;
  background: #fff !important;
  color: #2d8cf0 !important;
  font-size: 12px !important;
  box-shadow: none !important;

  &:hover,
  &:focus {
    border-color: #2d8cf0 !important;
    color: #1677ff !important;
    background: #f0f9ff !important;
  }

  &--compact {
    height: 24px;
    padding: 0 8px !important;
    font-size: 11px !important;
  }
}

.vc-hidden-file {
  display: none;
}

.vc-bg-sound.vc-card {
  padding-top: 16px;
  padding-bottom: 16px;
}

.vc-bg-sound__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.vc-bg-sound__label {
  font-size: 13px;
  font-weight: 500;
  color: #262626;
  line-height: 32px;
}

.vc-bg-sound__controls {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.vc-bg-sound__select-wrap {
  position: relative;
  width: 160px;
}

.vc-bg-sound__select {
  width: 100%;
}

.vc-bg-sound__select-wrap.has-value {
  ::v-deep .ivu-select-arrow {
    display: none;
  }

  ::v-deep .ivu-select-selected-value {
    padding-right: 28px;
  }
}

.vc-bg-sound__clear {
  position: absolute;
  top: 50%;
  right: 8px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: #c5c8ce;
  line-height: 1;
  transform: translateY(-50%);
  cursor: pointer;

  &:hover,
  &:focus-visible {
    color: #808695;
  }
}

.vc-bg-sound__volume {
  position: relative;
}

.vc-bg-sound__gear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin: 0;
  padding: 0;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  background: #fff;
  color: #808695;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;

  &:hover,
  &.is-open {
    border-color: #2d8cf0;
    color: #2d8cf0;
    background: #f0f9ff;
  }
}

.vc-bg-sound__popover {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 280px;
  padding: 12px 14px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08), 0 3px 6px rgba(0, 0, 0, 0.05);
}

.vc-bg-sound__popover-label {
  flex-shrink: 0;
  font-size: 13px;
  color: #262626;
  line-height: 32px;
}

.vc-bg-sound__slider {
  flex: 1;
  min-width: 0;
  margin: 0;

  ::v-deep .ivu-slider-wrap {
    margin: 10px 0;
  }
}

.vc-bg-sound__volume-input {
  width: 72px;
  flex-shrink: 0;

  ::v-deep .ivu-input-number-handler-wrap {
    display: none;
  }

  ::v-deep .ivu-input-number-input {
    text-align: center;
  }
}
</style>
